import { render, staticRenderFns } from "./faculty.vue?vue&type=template&id=7ce4f689&"
import script from "./faculty.vue?vue&type=script&lang=js&"
export * from "./faculty.vue?vue&type=script&lang=js&"
import style0 from "./faculty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports